/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/button-has-type */
/* eslint-disable import/no-unresolved */
import { render } from '@wordpress/element';
import ClassChart from './components/ClassChart';
import Header from './components/Header';
import Source from './components/Source';
import MapContainer from './components/MapContainer';
import './index.css';
import { UserProvider } from './context/context';

const MiddleClassMetroMap = () => {
    return (
        <UserProvider>
            <div id="interactive">
                <Header />
                <div id="mapWrap">
                    <MapContainer />
                    <ClassChart />
                </div>
                <Source />
            </div>
        </UserProvider>
    );
};

if (document.getElementById('js-middle-class-metro-map')) {
    render(
        <MiddleClassMetroMap />,
        document.getElementById('js-middle-class-metro-map'),
    );
}
